import { AxiosError } from "axios";
import { format } from "date-fns";

import api from "../api";
import { returnResponse } from "../utils";
import {
  ILogOperationResponse,
  ILogOperationTypeResponse,
} from "./interfaces";

export const ReportsService = {
  getTranscriptionKentaAI: async (
    customerId: number,
    startDate: Date,
    finishDate: Date,
  ) => {
    try {
      const startDateService = format(startDate, "yyyy-MM-dd") + " 00:00:00";
      const finishDateService = format(finishDate, "yyyy-MM-dd") + " 23:59:59";

      const { data } = await api.get(
        `/v1/Reports/GetTranscriptionReport?customerId=${customerId}&startDate=${startDateService}&endDate=${finishDateService}`,
      );

      return {
        status: true,
        data: data.data,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const messages = error?.response?.data?.errors;
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "An unexpected error occurred",
        });

        return {
          severity,
          status,
          message: message ? message : "Error",
          data,
        };
      }

      return {
        status: false,
        message: "Error",
        data: null,
        severity: "error",
      };
    }
  },

  async getAllLogErros(
    customerId: number,
    startDate: string,
    endDate: string,
    platform?: string | null,
  ) {
    try {
      const { data } = await api.get<any>(
        `/v1/LogError/GetAll?customerId=${customerId}&startDate=${startDate}&finishDate=${endDate}${
          platform ? `&platform=${platform}` : ""
        }`,
      );

      return {
        status: true,
        data: data,
        message: data.message,
      };
    } catch (err) {
      return {
        status: false,
        data: null,
        message: "An error occurred while fetching the records.",
      };
    }
  },

  async getAllLogOperations(
    customerId: number,
    startDate: string | null,
    endDate: string | null,
    operation: number | null,
    device: string | null,
  ) {
    try {
      const params = new URLSearchParams({
        customerId: customerId.toString(),
        startDate: startDate || "",
        finishDate: endDate || "",
      });

      if (operation) {
        params.append("operation", operation.toString());
      }

      if (device) {
        params.append("device", device);
      }

      const { data } = await api.get<ILogOperationResponse>(
        `/v1/LogOperation/GetAll?${params.toString()}`,
      );

      return {
        status: true,
        data: data,
        message: data.message,
      };
    } catch (err) {
      return {
        status: false,
        data: null,
        message: "An error occurred while fetching the records.",
      };
    }
  },

  async getOperations() {
    try {
      const { data } = await api.get<ILogOperationTypeResponse>(
        `/v1/LogOperation/GetOperations`,
      );

      return {
        status: true,
        data,
        message: data.message,
      };
    } catch (err) {
      return {
        status: false,
        data: null,
        message: "An error occurred while fetching the operations.",
      };
    }
  },

  async getLoggedUsers() {
    try {
      const { data } = await api.get<any>(`/v1/UserCustomerAccess/GetLoggedUsers`);
      return {
        status: true,
        data: data,
        message: data.message,
      };
    } catch (err) {
      return {
        status: false,
        data: null,
        message: "An error occurred while fetching the records.",
      };
    }
  },
};
